import getStore from '../store/store';
import { FeedbackCompoundCategory } from 'owa-feedback';

// This value is 50-6.
// The 50 comes from the max length of a feedback item in 'validateInlineFeedbackDialogProps.ts'
// And we subtract 6: 3 for the ' | ', and 3 for the '...'
const MAX_CONTEXT_LENGTH = 44;
const MAX_NUMBER_OF_SUGGESTIONS = 3;
const NEWLINE_REGEX = /\r\n|\n|\r/g;

export default function getSuggestionsFeedback(sessionId: string): FeedbackCompoundCategory[] {
    const allSuggestions = getStore().allSuggestionsTelemetry;
    const chosenSuggestions: FeedbackCompoundCategory[] = [];

    // use suggestions only from the current session
    allSuggestions.forEach(suggestion => {
        if (suggestion.suggestionReturned && suggestion.sessionId == sessionId) {
            chosenSuggestions.push({
                firstString: trimContext(suggestion.context, suggestion.suggestion).replace(
                    NEWLINE_REGEX,
                    ' '
                ),
                secondString: suggestion.suggestion.replace(NEWLINE_REGEX, ' '),
            });
        }
    });

    // remove duplicates
    const suggestionsUnique = dedupeSuggestions(chosenSuggestions);

    // use the latest suggestions
    while (suggestionsUnique.length > MAX_NUMBER_OF_SUGGESTIONS) {
        suggestionsUnique.shift();
    }

    return suggestionsUnique;
}

function trimContext(context: string, suggestion: string): string {
    const totalLength = context.length + suggestion.length;
    if (totalLength > MAX_CONTEXT_LENGTH) {
        return `...${context.substring(Math.max(totalLength - MAX_CONTEXT_LENGTH, 0))}`;
    }

    return context;
}

function dedupeSuggestions(suggestions: FeedbackCompoundCategory[]): FeedbackCompoundCategory[] {
    const uniqueSuggestions: FeedbackCompoundCategory[] = [];
    suggestions.forEach(suggestion => {
        if (
            uniqueSuggestions.filter(existingSuggestion => {
                return (
                    existingSuggestion.firstString + existingSuggestion.secondString ===
                    suggestion.firstString + suggestion.secondString
                );
            }).length === 0
        ) {
            uniqueSuggestions.push(suggestion);
        }
    });

    return uniqueSuggestions;
}
